import { useIsDesktop } from '@/hooks/use-screen'
import { ChevronLeftIcon, ChevronRightIcon } from 'lucide-react'
import ReactPaginate from 'react-paginate'

interface PaginationProps {
  activeIndex: number
  totalPage?: number
  onChange: (index: number) => void
}

export const Pagination: React.FC<PaginationProps> = ({ activeIndex = 1, totalPage, onChange, ...rest }) => {
  const isDesktop = useIsDesktop()
  if (!totalPage) return <></>
  if (totalPage <= 1) return <></>

  const handleChange = (index: number) => {
    if (activeIndex === index) {
      return
    }
    const throwTo = index - 1 === -1 ? 0 : index
    onChange(throwTo)
  }

  return (
    <div {...rest}>
      <ReactPaginate
        disabledClassName="!pointer-events-none mx-3 bg-transparent text-primary-blue rounded-full flex items-center justify-center"
        previousLabel={<ChevronLeftIcon width={20} />}
        nextLabel={<ChevronRightIcon width={20} />}
        previousClassName="border border-primary-blue text-primary-blue rounded-full h-9 w-9 flex items-center justify-center hover:bg-primary-blue hover:text-white transition-all mx-3"
        previousLinkClassName=""
        nextClassName="border border-primary-blue text-primary-blue rounded-full h-9 w-9 flex items-center justify-center hover:bg-primary-blue hover:text-white transition-all mx-3"
        nextLinkClassName=""
        breakLabel={'...'}
        pageCount={totalPage || 1}
        marginPagesDisplayed={1}
        pageRangeDisplayed={isDesktop ? 4 : 2}
        onPageChange={({ selected }) => handleChange(selected)}
        initialPage={activeIndex}
        containerClassName="flex px-3 gap-0.5"
        pageLinkClassName="flex rounded-full h-9 w-9 justify-center items-center text-sm font-medium hover:bg-primary-blue transition-all hover:text-white rounded-full"
        activeClassName="bg-primary-blue text-white rounded-full"
      />
    </div>
  )
}
